export const hasPermission = (
  permissions: { module: string; actions: string[] }[],
  moduleName: string,
  actionName: string
): boolean => {
  const module = permissions?.find((p) => p.module === moduleName);
  return module?.actions.includes(actionName) ?? false;
};
